module.exports = __webpack_public_path__ + "static/media/bus.f2ebc0c5.svg";